var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 0H16.6667C18.5 0 20 1.474 20 3.3V18.7C20 20.515 18.5 22 16.6667 22H3.33333C1.48889 22 0 20.515 0 18.7V3.3C0 1.474 1.48889 0 3.33333 0ZM10 9.9C11.2222 9.9 12.2222 8.91 12.2222 7.7C12.2222 6.479 11.2222 5.5 10 5.5C8.76667 5.5 7.77778 6.479 7.77778 7.7C7.77778 8.91 8.76667 9.9 10 9.9ZM4.44444 15.939C4.42222 16.115 4.73333 16.489 4.88889 16.489C9.38889 16.489 12.7889 16.489 15.0778 16.489C15.5333 16.489 15.5444 16.071 15.5333 15.939C15.3444 12.562 12.9222 10.989 9.96667 10.989C7.04445 10.989 4.65556 12.65 4.41111 15.928L4.44444 15.939Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.ef1377aa526b281c4e6c04f4366af01d.svg";
export { ForwardRef as ReactComponent };